/* Speech Recognition */

import { speechRecorder } from "@/utils/SpeechRecorder";

const DEFAULT_LANGUAGE = 'en-US'

class SpeechRecognizer {

    isRecognizing = false
    originalText;
    problemText;
    recordAudio = false
    lang = DEFAULT_LANGUAGE
    repeatDisableFlag = false
    recordedAudios = []
    recordedLatestAudio = null
    speechStartTime = null

    constructor(args) {
        this.originalText = args.originalText || ""
        this.lang = args.lang || DEFAULT_LANGUAGE
        this.component = args.component || null
    }

    getLatestAudio() {
        return this.recordedLatestAudio
    }

    playLatestAudio() { //needs to be accessed after the final result
        const blob = this.recordedLatestAudio
        const audio = new Audio(URL.createObjectURL(blob));
        audio.play()
    }

    startOnlyRecog() {
        this.sr.start()
    }

    stopOnlyRecog() {
        this.isRecognizing = false
        this.audioDisableFlag = true
        this.sr.stop()
        // console.log("stop recognizing.")
    }

    stopRecog() {
        this.isRecognizing = false
        this.audioDisableFlag = true
        this.sr.stop()
        speechRecorder.stopRecord().then((audioBlob) => {
            this.recordedLatestAudio = audioBlob
            speechRecorder.clearSavedAudios();
            // console.log("cleared")
        });
        // console.log("stop recognizing.")
    }

    removeListeners() {
        this.sr.removeListeners('result'); // needs a argument func
        document.removeListeners('speech-result'); // needs a argument func
    }

    startRecog() {
        if (!this.isRecognizing && this.component.activeTraining) { // check setted vue component's data property reference
            const self = this
            this.isRecognizing = true
            this.audioDisableFlag = false
            window.SpeechRecognition =
                window.SpeechRecognition || window.webkitSpeechRecognition
            this.sr = new window.SpeechRecognition()
            this.sr.lang = this.lang
            this.sr.interimResults = true
            this.sr.start()
            // console.log("start recognizing from startRecog()")
            speechRecorder.startRecord()
            this.recordStartTime = performance.now()
            this.sr.addEventListener('result', e => {

                const isFinal = e.results[0].isFinal

                if (isFinal) {
                    speechRecorder.stopRecord().then((blob) => {
                        const ev = new CustomEvent('speech-result', {
                            detail: {
                                textOriginal: e.results[0][0].transcript,
                                isFinal,
                                confidence: e.results[0][0].confidence,
                                audio: blob,
                                offsetDuration: (this.speechStartTime - this.recordStartTime)  // to msc
                            }
                        })
                        document.dispatchEvent(ev)
                    });
                } else {
                    const ev = new CustomEvent('speech-result', {
                        detail: {
                            textOriginal: e.results[0][0].transcript,
                            isFinal,
                            confidence: e.results[0][0].confidence,
                        }
                    })
                    document.dispatchEvent(ev)
                }

            })
            this.sr.addEventListener('end', () => {
                if (!this.audioDisableFlag) {
                    speechRecorder.stopRecord();
                    self.sr.start()
                    // console.log("start recognizing from end event listener")
                    speechRecorder.startRecord();
                    this.recordStartTime = performance.now()
                }
            })

            this.sr.addEventListener('speechstart', () => {
                this.speechStartTime = performance.now()
            })

        }
    }
}

export default SpeechRecognizer
